export var SmsOperatorType;
(function (SmsOperatorType) {
    SmsOperatorType["MEMBER"] = "member";
    SmsOperatorType["SYSTEM"] = "system";
    SmsOperatorType["ADMIN"] = "admin";
})(SmsOperatorType || (SmsOperatorType = {}));
//# sourceMappingURL=SmsOperatorType.js.map